import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import {ProjektItem} from '../../projekt.model';
import {MitarbeiterItem} from '../../../Mitarbeiterverwaltung/mitarbeiter.model';

@Component({
    selector: 'app-projekt-table',
    templateUrl: './projekt-table.component.html',
    styleUrls: ['./projekt-table.component.scss'],
})
export class ProjektTableComponent implements OnInit {
  public displayedColumns: string[] = [
    'projektnr',
    'projektname',
    'projektstart',
    'projektende',
    'actions',
  ];
  public dataSource = new MatTableDataSource<ProjektItem>();

  @Output()
  public deleteProjekt = new EventEmitter<number>();

  @Output()
  public editProjekt = new EventEmitter<ProjektItem>();

  @Input()
  public set projekte(projekte: ProjektItem[]) {
    this.dataSource.data = projekte;
  }
  /**
   * Sets addresses to datasource
   *
   * @param addresses - The addresses
   */

    /**
     * Executed in initialization
     */
    public ngOnInit(): void {

    }
}
